export const environment = {
  production: false,
  seguros_old:'https://s3.amazonaws.com/s3.mundojoven.com/nuevo_motor_seguros/',
  api: {
    wp: 'https://mundojoven.com/wp-json/',
    s3: 'https://s3-us-west-2.amazonaws.com/s32019.mundojoven.com/mjweb2019/wp-content/uploads/',
    fuv: 'https://fuv-back.mundojoven.com/fuv_core_api/',
    mj: 'https://mundojoven.com/wp-content/themes/MundoJoven2019/dist/assets/',
    tCompositor: {
      urlMJ: 'http://tours.mundojoven.com/ES/holidays/search',
      url: 'https://online.travelcompositor.com/resources/',
      microsite: 'mundojoven',
      username: 'apiuser',
      password: '123456'
    }
  },
  backend:{
    //vuelos:'http://10.20.30.104:8080/flight_back/'
    vuelos:'https://web-back.mundojoven.com/flight_back/',
    urlBase: 'https://mundojoven.com/'
  },
  map_key: 'AIzaSyB2nlNR02fVECJkP3iOIgtLNDpkyr0HPso'
};
